<template>
  <div class="miami">
    <ScrollupSection />
    <div class="all-area">
      <HeaderSection />
      <HeroSection />
      <PromoSection />
      <AboutSection />
      <WorkSection />
      <FeatureSection />
      <ScreenshotSection />
      <DownloadSection />
      <ContactSection />
      <FooterSection />
    </div>
  </div>
</template>

<script>
import ScrollupSection from '../components/Scrollup/Scrollup'
import HeaderSection from '../components/Header/HeaderOne'
import HeroSection from '../components/Hero/HeroOne'
import PromoSection from '../components/Promo/PromoOne'
import AboutSection from '../components/About/About'
import WorkSection from '../components/Work/Work'
import FeatureSection from '../components/Features/Features'
import ScreenshotSection from '../components/Screenshots/Screenshots'
import DownloadSection from '../components/Download/Download'
import ContactSection from '../components/Contact/Contact'
import FooterSection from '../components/Footer/Footer'

export default {
  name: 'ThemeOne',
  components: {
    ScrollupSection,
    HeaderSection,
    HeroSection,
    PromoSection,
    AboutSection,
    WorkSection,
    FeatureSection,
    ScreenshotSection,
    DownloadSection,
    ContactSection,
    FooterSection
  },
  metaInfo: {
    title: "By Rule - Rule The Game"
  }
}
</script>

<style>

</style>